// extracted by mini-css-extract-plugin
export default {"root":"spinner_root__8g4oC","loader":"spinner_loader__1yPjQ","stripes-animation-background-keyframes":"spinner_stripes-animation-background-keyframes__de231"};